import { Box, Button, CircularProgress, Grid, IconButton, Typography } from '@mui/material';
import { MFSubmitButton, MFTextField } from '../../lib/formik';
import { Formik, useFormikContext, validateYupSchema, yupToFormErrors } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import {
  Distributor,
  getDistributors,
  getDistributorsResponse,
  SubDistributor,
} from '../../redux-store/actions';
import React, { useEffect, useState } from 'react';
import { RootStateType } from '../../redux-store/reducers';
import { updateApplication } from '../../redux-store/actions/application';
import { useHistory, useParams } from 'react-router';
import {
  AMC_APPROVER_CHECK_FOR_INDIVIDUAL,
  APPLICATION_LISTING_STATUS,
  BankAccountTypeMaster,
  CustodianMaster,
  NDPSMBankMaster,
  SAVE_LATER_VALIDATION_CHECK,
  USER_ROLES,
  addressForTaxsMasters,
  applicantStatusMasters,
  mappingRmWithDistributors,
  srmMappedUsersMaster,
} from '../../utils/constant';
import { InfoDialog, Notes, ProceedSaveLater, SubHeading } from './components';
import UseRadioGroup from '../../lib/formik/Radio';
import { distributorsValidationSchema } from '../../utils/schema';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import {
  applicationComparison,
  applyRoleBasedStatus,
  checkApplicableForYes,
  checkNDPMS,
  disableBankDetail,
  getAllStrategiesByDistributorType,
  getApplicantIdForInvestorPhotoCapture,
  isBankDetailsChanged,
  isCustodianKotak,
  saveForLater,
  saveForLaterInvestorPhotoCapture,
  shouldValidateUponSaveLater,
  showPopBankDetail,
} from '../../utils/utilityFunctions';
import { SearchableSelect } from '../../lib/formik/searchSelectField';
import { ConfirmationDialog } from '../commonComponents';
import MFSelectField from '../../lib/formik/SelectField';
import { useSnackbar } from 'notistack';
import { OnEditDialogBox } from './additionalKYCDetails';
import { refLoginCheck } from '../Investments/investor-application';
import {
  ApplicantAddressType,
  ApplicationProps,
  DistributorListType,
  mappedUserMasterType,
  mappedUserUnderSrmType,
  RmsType,
  RMType,
  StrategyDetailsType,
} from '../../redux-store/types/api-types';
import FieldValidationNote from './FieldValidationNote';
import { GetStrategiesResponseBody } from '../../redux-store/types/strategies';
import { getDistributorById, getMappedUserList } from '../../redux-store/actions/userManagement';

type DistributorDetailsProps = {
  nismNumber: string | null;
  distributorNismNumber: string | null;
  subDistributorNismNumber: string | null;
  distributorName: string | null;
  distributorPhone: string | null;
  distributorEmail: string | null;
  distributorId: number | null;
  distributorType: string | null;
  loginType: string;
  firstName: string;
  empCode: string;
  phone: string | undefined;
  email: string;
  subdistributorId: number | null;
  subdistributorName: string | null;
  subdistributorEmail: string | null;
  subdistributorPhone: string | null;
  filledBy: string | null;
  saveType: string;
  custodian: string;
  rm_id: number | undefined;
  mappedUserId: string;
  bankDetails: string | null;
  srmName?: string;
  srmEmail?: string;
  srmPhone?: string;
};

function GridItem({ children }: { children: React.ReactNode }) {
  return (
    <Grid item xs={12} sm={6}>
      {children}
    </Grid>
  );
}

const RMDetail = () => {
  return (
    <>
      <GridItem>
        <MFTextField
          name="firstName"
          label="RM's Name"
          placeholder="Enter RM name"
          disabled={true}
        />
      </GridItem>
      <GridItem>
        <MFTextField
          name="email"
          label="RM's Email Address"
          placeholder="Enter RM Email ID"
          disabled={true}
        />
      </GridItem>
      <GridItem>
        <MFTextField
          name="phone"
          label="RM's Mobile Number"
          placeholder="Enter RM's Mobile Number"
          disabled={true}
        />
      </GridItem>
      <GridItem>
        <MFTextField
          name="nismNumber"
          label="RM's NISM Certificate Number"
          placeholder="Enter NISM Certificate Number"
          disabled={true}
        />
      </GridItem>
      {/* <GridItem>
        <MFTextField
          name="empCode"
          label="Employee Code"
          placeholder="Enter Employee Code"
          disabled={true}
        />
      </GridItem> */}
    </>
  );
};

const DistributorDetail = ({
  handleDialogOpen,
  distributors,
  values,
  selectedDistributor,
  setSelectedDistributor,
  isDistributorIdActive = false,
}: {
  handleDialogOpen: (message: string) => void;
  distributors: Distributor[];
  values: DistributorDetailsProps;
  selectedDistributor: SubDistributor[];
  setSelectedDistributor: (distributor: SubDistributor[]) => void;
  isDistributorIdActive?: boolean;
}): JSX.Element => {
  const { role, id: authId = '' } = useSelector((store: RootStateType) => store.auth);
  const { setValues } = useFormikContext();
  const [open, setOpen] = useState(false);
  const referenceDetail = useSelector((store: RootStateType) => store.refrenceIdReducer);
  const { application } = useSelector((store: RootStateType) => store.application);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const userIsRia =
    values.loginType === USER_ROLES.RIA ||
    checkApplicableForYes(
      distributors?.find((item) => item?.id === values.distributorId)?.isRia || ''
    );

  const amcuserAsInvestor = refLoginCheck(
    authId,
    application as unknown as ApplicationProps,
    referenceDetail
  );

  return (
    <>
      {distributors.length > 0 ? (
        <>
          {[USER_ROLES.RM].includes(role) && values.distributorId && (
            <Grid item xs={12} sx={{ textAlign: 'right' }}>
              <Button
                variant="contained"
                sx={{
                  color: 'white',
                  fontWeight: 500,
                  fontSize: 14,
                  py: 0.5,
                  px: 3,
                }}
                onClick={() =>
                  handleDialogOpen(
                    `Are you sure you want to clear ${userIsRia ? 'RIA' : 'Distributor'} details ?`
                  )
                }>
                Clear
              </Button>
            </Grid>
          )}
          <GridItem>
            <SearchableSelect
              name="distributorId"
              label={`${userIsRia ? 'RIA' : 'Distributor'} Code *`}
              items={distributors
                .sort((distributor1, distributor2) =>
                  (distributor1['name'] || '')
                    .toString()
                    .localeCompare((distributor2['name'] || '').toString())
                )
                .map((item) => ({
                  key: (item?.name || 'NA') + ' - ' + item?.arnCode,
                  value: item?.id,
                }))}
              onChange={({ target: { value } }) => {
                const distributorCode = distributors.find((item) => item.id === value);
                const { id = null, name, nismNumber, user, type } = distributorCode || {};
                const { email, phone } = user || {};
                setValues({
                  ...values,
                  distributorName: name,
                  distributorNismNumber: nismNumber,
                  distributorPhone: phone,
                  distributorEmail: email,
                  distributorType: type,
                  distributorId: id,
                  subdistributorId: null,
                  subdistributorName: null,
                  subDistributorNismNumber: null,
                  subdistributorEmail: null,
                  subdistributorPhone: null,
                });
                setSelectedDistributor(
                  distributors.find((distributor) => distributor.id === value)?.subdistributors ||
                    []
                );
              }}
              disabled={
                [
                  USER_ROLES.DISTRIBUTOR,
                  USER_ROLES.INVESTOR,
                  USER_ROLES.POAAPPROVER,
                  USER_ROLES.SUBDISTRIBUTOR,
                ].includes(role) ||
                amcuserAsInvestor ||
                isDistributorIdActive
              }
              applyRenderValue={true}
              searchFieldPlaceholder={`Search ${userIsRia ? 'RIA' : 'Distributor'}`}
            />
          </GridItem>

          <GridItem>
            <MFTextField
              name="distributorName"
              label={`${userIsRia ? 'RIA' : 'Distributor'} Name *`}
              placeholder={`Enter ${userIsRia ? 'RIA' : 'Distributor'} Name`}
              disabled={true}
            />
          </GridItem>
          {values?.distributorId && values?.distributorType === 'individual' && (
            <>
              <GridItem>
                <MFTextField
                  name="distributorEmail"
                  label={`${userIsRia ? 'RIA' : 'Distributor'} Email`}
                  placeholder={`Enter ${userIsRia ? 'RIA' : 'Distributor'} Email`}
                  disabled={true}
                />
              </GridItem>
              <GridItem>
                <MFTextField
                  name="distributorPhone"
                  label={`${userIsRia ? 'RIA' : 'Distributor'}  Mobile Number`}
                  placeholder={`Enter ${userIsRia ? 'RIA' : 'Distributor'} Mobile Number`}
                  disabled={true}
                />
              </GridItem>
              <GridItem>
                <MFTextField
                  name="distributorNismNumber"
                  label={`${userIsRia ? 'RIA' : 'Distributor'} NISM Certificate Number *`}
                  placeholder={`Enter ${userIsRia ? 'RIA' : 'Distributor'} NISM Certificate Number`}
                  disabled={true}
                />
              </GridItem>
            </>
          )}
          {!!selectedDistributor?.length && (
            <>
              <GridItem>
                <SearchableSelect
                  name="subdistributorId"
                  label={`${userIsRia ? "RIA's" : "Distributor's"} RM Code *`}
                  items={selectedDistributor
                    .sort((subDistributor1, subDistributor2) =>
                      (subDistributor1.user['firstName'] || '')
                        .toString()
                        .localeCompare((subDistributor2.user['firstName'] || '').toString())
                    )
                    .map((item) => ({
                      key: item.user.firstName + ' - ' + (item.distributors_RM_Code || 'NA'),
                      value: item.id,
                    }))}
                  onChange={({ target: { value } }) => {
                    const distributorCode = selectedDistributor.find((item) => item.id === value);
                    const { id = null, user, nismNumber } = distributorCode || {};
                    const { email, phone, firstName = '' } = user || {};
                    setValues({
                      ...values,
                      subdistributorId: id,
                      subdistributorEmail: email,
                      subdistributorPhone: phone,
                      subdistributorName: firstName,
                      subDistributorNismNumber: nismNumber,
                    });
                  }}
                  disabled={
                    [
                      USER_ROLES.DISTRIBUTOR,
                      USER_ROLES.INVESTOR,
                      USER_ROLES.POAAPPROVER,
                      USER_ROLES.SUBDISTRIBUTOR,
                    ].includes(role) || amcuserAsInvestor
                  }
                  searchFieldPlaceholder={`Search ${userIsRia ? "RIA's" : "Distributor's"} RM`}
                />
              </GridItem>
              <GridItem>
                <MFTextField
                  name="subdistributorName"
                  label={`${userIsRia ? "RIA's" : "Distributor's"} RM Name *`}
                  placeholder={`Enter ${userIsRia ? 'RIA' : 'Distributor'} Name`}
                  disabled={true}
                />
              </GridItem>
              <GridItem>
                <MFTextField
                  name="subdistributorEmail"
                  label={`${userIsRia ? "RIA's" : "Distributor's"} RM Email`}
                  placeholder={`Enter ${userIsRia ? 'RIA' : 'Distributor'} Email`}
                  disabled={true}
                />
              </GridItem>
              <GridItem>
                <MFTextField
                  name="subdistributorPhone"
                  label={`${userIsRia ? "RIA's" : "Distributor's"} RM Phone`}
                  placeholder={`Enter ${userIsRia ? 'RIA' : 'Distributor'}'s Phone`}
                  disabled={true}
                />
              </GridItem>
              <GridItem>
                <MFTextField
                  name="subDistributorNismNumber"
                  label={`${userIsRia ? "RIA's" : 'Distributor'}'s  RM NISM Certificate Number`}
                  placeholder={`Enter ${
                    userIsRia ? 'RIA' : 'Distributor'
                  }  RM NISM Certificate Number`}
                  disabled={true}
                />
              </GridItem>
            </>
          )}
          {!application?.srm_id && (
            <GridItem>
              <MFTextField name="filledBy" label="Filled by" placeholder="Enter filled by" />
              <Typography
                component="span"
                sx={{ position: 'relative', left: 64, bottom: { xs: 85, md: 91 } }}>
                <InfoOutlinedIcon color="info" fontSize="small" onClick={handleOpen} />
              </Typography>
            </GridItem>
          )}
          <InfoDialog
            onClose={handleClose}
            open={open}
            content={'Please add the Name of the Subdistributor RM.'}
          />
        </>
      ) : (
        <Grid
          xs={12}
          sm={12}
          sx={{
            fontSize: 18,
            fontWeight: 500,
            color: 'rgb(97, 209, 214)',
            display: 'flex',
            alignItems: 'center',
            textAlign: 'center',
            justifyContent: 'center',
            mt: { lg: 9, xs: 9 },
            mb: 2.9,
            ml: { xs: 3 },
          }}>
          {`No  ${
            values?.loginType === USER_ROLES.RIA ? 'RIA' : 'distributor'
          } mapped under this RM`}
        </Grid>
      )}
    </>
  );
};

const SRMDetail = ({
  savedDistributors,
  handleDialogOpen,
  values,
  selectedDistributor,
  setSelectedDistributor,
  mappedusersDetailsList,
}: {
  savedDistributors: Distributor[];
  handleDialogOpen: (message: string) => void;
  values: DistributorDetailsProps;
  selectedDistributor: SubDistributor[];
  setSelectedDistributor: any;
  mappedusersDetailsList: mappedUserUnderSrmType;
}) => {
  const [srmsLoading, setSrmsLoading] = useState(false);
  const [distributor, setDistributor] = useState<Distributor[]>([]);
  const dispatch = useDispatch();
  const { role, id: authId = '' } = useSelector((store: RootStateType) => store.auth);
  const { setValues } = useFormikContext();
  const referenceDetail = useSelector((store: RootStateType) => store.refrenceIdReducer);
  const { application } = useSelector((store: RootStateType) => store.application);

  const mappedusersList = mappedusersDetailsList?.mappedUsers?.map((users, index) => {
    let role = '';
    if (users?.isRia) {
      role = checkApplicableForYes(users?.isRia) ? 'ria' : 'distributor';
    } else if (users?.user?.role) {
      role = users?.user?.role;
    }
    return {
      name: users?.name,
      id: users?.id || null,
      type: users?.type || '',
      role: role,
    };
  });

  const addUserDetails = async (mappedUserDetail: string) => {
    const idAndRole = mappedUserDetail?.split('-');
    const userRole = idAndRole[1] === 'ria' ? 'distributor' : idAndRole[1];
    const userId = parseInt(idAndRole[0], 10);
    if (srmMappedUsersMaster[userRole] === srmMappedUsersMaster?.rm) {
      const selectedRM = (mappedusersDetailsList?.mappedUsers as RMType[])?.find(
        (user) => user?.id === userId && user?.user?.role === userRole
      );
      setValues({
        ...values,
        mappedUserId: mappedUserDetail || '',
        rm_id: selectedRM?.id || null,
        phone: selectedRM?.user?.phone || '',
        firstName: selectedRM?.user?.firstName || '',
        email: selectedRM?.user?.email || '',
        nismNumber: selectedRM?.nismNumber || '',
        distributorNismNumber: null,
        subDistributorNismNumber: null,
        distributorId: null,
        distributorName: '',
        distributorPhone: '',
        distributorEmail: '',
        distributorType: '',
        subdistributorId: null,
        subdistributorName: null,
        subdistributorEmail: null,
        subdistributorPhone: null,
      });
      setSelectedDistributor([]);
    } else if (srmMappedUsersMaster[userRole] === srmMappedUsersMaster?.distributor) {
      try {
        const mappedDistributor = (
          mappedusersDetailsList?.mappedUsers as DistributorListType[]
        )?.find((user) => {
          return user?.id === userId && (user?.user?.role === 'distributor' || user?.isRia);
        });

        if (mappedDistributor?.type === 'company') {
          setSrmsLoading(true);
          const res = (await dispatch(
            getDistributorById(mappedDistributor?.id as number)
          )) as unknown as Distributor;

          setDistributor([res]);
          setSelectedDistributor(res?.subdistributors || []);
        } else {
          setDistributor([mappedDistributor || {}] as Distributor[]);
          setSelectedDistributor([]);
        }
        setValues({
          ...values,
          mappedUserId: mappedUserDetail || '',
          rm_id: null,
          phone: '',
          firstName: '',
          email: '',
          nismNumber: '',
          distributorNismNumber: mappedDistributor?.nismNumber,
          distributorId: mappedDistributor?.id,
          distributorName: mappedDistributor?.name,
          distributorPhone: mappedDistributor?.user?.phone,
          distributorEmail: mappedDistributor?.user?.email,
          distributorType: mappedDistributor?.type,
          subdistributorId: null,
          subdistributorName: null,
          subdistributorEmail: null,
          subdistributorPhone: null,
          subDistributorNismNumber: null,
        });
        setSrmsLoading(false);
      } catch (e: unknown) {
        setSrmsLoading(false);
        console.error((e as Error).message);
      }
    }
  };

  const amcuserAsInvestor = refLoginCheck(
    authId,
    application as unknown as ApplicationProps,
    referenceDetail
  );

  return (
    <>
      <Grid item xs={12}>
        <SubHeading sx={{ color: 'common.primary', letterSpacing: 0.5 + 'px' }}>
          SRM Details
        </SubHeading>
      </Grid>
      <GridItem>
        <MFTextField
          name="srmName"
          label="SRM's Name"
          placeholder="Enter RM name"
          disabled={true}
        />
      </GridItem>
      <GridItem>
        <MFTextField
          name="srmEmail"
          label="SRM's Email Address"
          placeholder="Enter SRM's Email Address"
          disabled={true}
        />
      </GridItem>
      <GridItem>
        <MFTextField
          name="srmPhone"
          label="SRM's Mobile Number"
          placeholder="Enter SRM's Mobile Number"
          disabled={true}
        />
      </GridItem>
      <GridItem>
        <SearchableSelect
          name="mappedUserId"
          label="Mapped Users *"
          items={(mappedusersList || [])?.map((item: mappedUserMasterType) => ({
            key: `${item?.name} (${item?.type ? item?.type + ' ' : ''}${
              srmMappedUsersMaster[item?.role || '']
            })`,
            value: `${item?.id}-${item?.role !== 'rm' ? 'distributor' : 'rm'}` as string,
          }))}
          onChange={({ target: { value } }) => {
            addUserDetails((value || '') as string);
          }}
          disabled={
            [
              USER_ROLES.DISTRIBUTOR,
              USER_ROLES.INVESTOR,
              USER_ROLES.POAAPPROVER,
              USER_ROLES.AMC_ADMIN,
              USER_ROLES.SUBDISTRIBUTOR,
            ].includes(role) ||
            amcuserAsInvestor ||
            srmsLoading
          }
          applyRenderValue={false}
          searchFieldPlaceholder="Search Mapped Users"
        />
        {srmsLoading && (
          <Box sx={{ display: 'flex' }}>
            <CircularProgress size={30} />
          </Box>
        )}
      </GridItem>
      {values?.rm_id && (
        <>
          <Grid item xs={12}>
            <SubHeading sx={{ color: 'common.primary', letterSpacing: 0.5 + 'px' }}>
              RM Details
            </SubHeading>
          </Grid>
          <RMDetail />
        </>
      )}
      {values?.distributorId && (
        <>
          <Grid item xs={12}>
            <SubHeading sx={{ color: 'common.primary', letterSpacing: 0.5 + 'px' }}>
              Distributor Details
            </SubHeading>
          </Grid>

          <DistributorDetail
            handleDialogOpen={handleDialogOpen}
            distributors={distributor?.length > 0 ? distributor : savedDistributors}
            values={values}
            selectedDistributor={selectedDistributor}
            setSelectedDistributor={setSelectedDistributor}
            isDistributorIdActive={true}
          />
        </>
      )}
    </>
  );
};

export default function DistributorDetails(): JSX.Element {
  const dispatch = useDispatch();
  const history = useHistory();
  const [distributors, setDistributors] = useState<Distributor[]>([]);
  const { application } = useSelector((store: RootStateType) => store.application);
  const { role, id: authId = '' } = useSelector((store: RootStateType) => store.auth);
  const [selectedDistributor, setSelectedDistributor] = useState<SubDistributor[]>([]);
  const [loading, setLoading] = useState(false);
  const [openDialog, setDialog] = useState(false);
  const [loginTypeRole, setLoginTypeRole] = useState('');
  const [dialogMessage, setDialogMessage] = useState('');
  const { enqueueSnackbar } = useSnackbar();
  const referenceDetail = useSelector((store: RootStateType) => store.refrenceIdReducer);
  const [showDialogForEdit, setShowShowForEdit] = useState(false);
  const [finalvalue, setFinalValue] = useState<any>();
  const [buttonDisable, setButtonDisable] = useState(false);
  const [mappedusersDetailsList, setMappedusersDetailsList] = useState<mappedUserUnderSrmType>();
  const {
    distributor,
    rm,
    srm,
    subdistributorId = null,
    subDistributor,
    filledBy = '',
    custodian = '',
    bankDetails = '',
    accountType,
    bankAccountTypeNdpms = '',
  } = application || {};

  const {
    name,
    id,
    type = '',
  } = distributor || {
    arnCode: '',
    name: '',
    id: null,
  };
  const {
    user: { email: distributorEmail, phone: distributorPhone = '' },
  } = distributor || { user: { phone: '', email: '' } };
  const {
    empCode,
    nismNumber,
    user: { id: rmId, email: RMEmail = '', firstName: RMFirstName = '', phone },
  } = rm || { empCode: '', nismNumber: '', user: { email: '' } };

  const {
    name: srmName,
    user: { email: srmEmail = '', phone: srmPhone },
  } = srm || { user: { email: '', phone: undefined } };

  const {
    user: {
      firstName: subdistributorName,
      email: subdistributorEmail,
      phone: subdistributorPhone = '',
    },
  } = subDistributor || { user: { firstName: '', email: '' } };

  const mappedUserId = id
    ? `${id}-distributor`
    : application?.rm_id
    ? `${application?.rm_id}-rm`
    : '';

  const initialValues: DistributorDetailsProps = {
    distributorId: id,
    distributorName: name,
    distributorNismNumber: distributor?.nismNumber || '',
    subDistributorNismNumber: subDistributor?.nismNumber || '',
    nismNumber: nismNumber,
    distributorPhone: distributorPhone,
    distributorEmail: distributorEmail,
    distributorType: type,
    loginType: application?.srm_id ? role : 'rm',
    rm_id: application?.rm_id,
    empCode,
    email: RMEmail,
    phone: phone,
    firstName: RMFirstName,
    subdistributorId: subdistributorId === null ? subdistributorId : Number(subdistributorId),
    subdistributorName,
    subdistributorEmail,
    subdistributorPhone,
    filledBy,
    saveType: 'save and proceed',
    custodian: 'ICICI',
    mappedUserId: mappedUserId,
    bankDetails: 'None',
    srmName,
    srmEmail,
    srmPhone,
  };
  const handleDialogOpen = (message: string) => {
    setDialogMessage(message);
    setDialog(true);
  };
  const handleDialogClose = () => {
    setDialog(false);
    setDialogMessage('');
    setLoginTypeRole('');
  };
  useEffect(() => {
    let isComponentActive = true;
    (async function () {
      try {
        setLoginTypeRole(role || '');
        if (Object.keys(application || {}).length && role === USER_ROLES.RM) {
          const res = (await dispatch(
            getDistributors({ isActive: true })
          )) as unknown as getDistributorsResponse;
          const { distributors = [] } = res || {};
          const updatedDistributor =
            application?.distributor_id && !application.distributor.isActive
              ? [
                  ...distributors,
                  {
                    ...application.distributor,
                    subdistributors: [application.subDistributor],
                  } as Distributor,
                ]
              : distributors;
          if (isComponentActive) {
            const updateSubdistributor =
              application?.distributor_id &&
              application?.distributor.isActive &&
              application?.subdistributorId &&
              !application.subDistributor?.isActive
                ? [
                    ...(updatedDistributor.find((distributor) => distributor.id === id)
                      ?.subdistributors || []),
                    { ...application.subDistributor },
                  ]
                : updatedDistributor.find((distributor) => distributor.id === id)
                    ?.subdistributors || [];
            setSelectedDistributor(updateSubdistributor as unknown as SubDistributor[]);
            setDistributors(updatedDistributor as unknown as Distributor[]);

            // console.log(loginType, 'selected distri');
          }
        } else if (Object.keys(application || {}).length && role === USER_ROLES.SRM) {
          setLoginTypeRole(role || '');
          const res = (await dispatch(
            getMappedUserList({ isActive: true })
          )) as unknown as mappedUserUnderSrmType;

          const savedUsers = rmId ? rm : application?.distributor_id ? distributor : null;
          const updatesres: mappedUserUnderSrmType = {
            mappedUsersIdAndRole: (savedUsers
              ? [
                  ...(res.mappedUsersIdAndRole || []),
                  {
                    mappedUserRole: savedUsers.user?.role || '',
                    mappedUserRoleId: savedUsers.user?.id as number,
                  },
                ]
              : res.mappedUsersIdAndRole || []
            )?.filter(
              (user, index, self) =>
                index ===
                self.findIndex(
                  (_itemUser) =>
                    _itemUser.mappedUserRoleId === user.mappedUserRoleId &&
                    _itemUser.mappedUserRole === user.mappedUserRole
                )
            ),

            mappedUsers: (savedUsers
              ? [...(res?.mappedUsers || []), savedUsers as any]
              : res?.mappedUsers || []
            )?.filter(
              (user, index, self) =>
                index ===
                self.findIndex(
                  (itemUser) =>
                    'id' in itemUser &&
                    (itemUser.isRia
                      ? itemUser.isRia === user.isRia && itemUser.id === user.id
                      : itemUser?.user?.role === user?.user?.role && itemUser.id === user.id)
                )
            ),
          };

          setMappedusersDetailsList(updatesres);

          const selectedDistributor = (res?.mappedUsers as DistributorListType[])
            ?.map((user) => {
              return { ...user, isRia: user?.isRia || 'no' };
            })
            ?.find((item) => {
              return item?.isRia && item?.id === application?.distributor_id;
            });

          if (application?.distributor_id) {
            const updatedDistributor =
              application?.distributor_id && !application.distributor.isActive
                ? [
                    ...[selectedDistributor],
                    {
                      ...application.distributor,
                      subdistributors: [application.subDistributor],
                    } as Distributor,
                  ]
                : [selectedDistributor];

            if (isComponentActive) {
              setSelectedDistributor(
                (application?.subDistributor?.id
                  ? [application?.subDistributor || {}]
                  : []) as unknown as SubDistributor[]
              );
              setDistributors(updatedDistributor as unknown as Distributor[]);
            }
          }
        } else {
          const { distributor, subDistributor, rm } = application || {};
          setMappedusersDetailsList({
            mappedUsersIdAndRole: [],
            mappedUsers: [distributor || {}, rm || {}] as
              | (RMType & { isRia: string; type: string })[]
              | DistributorListType[],
          });
          setDistributors(distributor ? [distributor as Distributor] : []);
          setSelectedDistributor(
            subDistributor
              ? [{ ...subDistributor, id: Number(subDistributor.id) } as SubDistributor]
              : []
          );
        }
      } catch (e: unknown) {
        console.error((e as Error).message);
      }
    })();
    return () => {
      isComponentActive = false;
    };
  }, [application]);

  const { referenceId: referenceIdForInvestorPhotoCapture } = useParams<{ referenceId: string }>();
  const handleapplicationComparison = (
    values: DistributorDetailsProps,
    application: ApplicationProps | null,
    applicationStrategydetails = {},
    applicants = application?.applicants,
    isSaveLater: boolean
  ): boolean => {
    const { distributorId, subdistributorId, filledBy, custodian, bankDetails, rm_id, saveType } =
      values;
    return applicationComparison(application, {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      ...application!,
      rm_id,
      distributor_id: distributorId,
      subdistributorId: subdistributorId ? subdistributorId.toString() : subdistributorId,
      filledBy: filledBy,
      custodian,
      bankDetails: checkNDPMS(accountType) ? bankDetails : '',
      currentStep: SAVE_LATER_VALIDATION_CHECK
        ? application?.currentStep === null
          ? 1
          : application?.currentStep
        : isSaveLater
        ? 0
        : application?.currentStep || 1,
      ...applicationStrategydetails,
      applicants,
    });
  };
  const onSubmit = async (values: DistributorDetailsProps) => {
    try {
      const {
        distributorId,
        subdistributorId,
        filledBy,
        custodian,
        bankDetails,
        mappedUserId,
        srmEmail,
        srmName,
        srmPhone,
        saveType,
      } = values;
      const {
        id,
        applicant1ReferenceId,
        currentStep = null,
        banks,
        status,
        hasPOA,
        applicationNumber,
      } = application || {};
      const isSaveLater = saveType !== 'save and proceed';
      let applicationStrategydetails = {};
      let response = [] as GetStrategiesResponseBody[];
      let applicants = application?.applicants;

      const riaInSrmList = (
        (mappedusersDetailsList?.mappedUsers || []) as DistributorListType[]
      )?.find((item) => item?.isRia && item.id === distributorId)?.isRia;

      const isDistributorPresent =
        !distributorId &&
        application?.distributor_id &&
        (application?.applicationstrategydetails || [])?.length > 0;
      if (distributorId || isDistributorPresent) {
        try {
          if (
            (distributorId && Number(distributorId) !== Number(application?.distributor_id)) ||
            isDistributorPresent
          ) {
            setButtonDisable(true);
            response = (await getAllStrategiesByDistributorType(dispatch, {
              ...application,
              distributor: {
                ...application?.distributor,
                isRia: (riaInSrmList ? riaInSrmList : application?.distributor?.isRia) || '',
              },
              distributor_id: distributorId,
            } as ApplicationProps)) as unknown as GetStrategiesResponseBody[];
          }

          setButtonDisable(false);
          const responseId = response?.map((responseIdData) => responseIdData.id?.toString());

          if ((application?.applicationstrategydetails || [])?.length > 0) {
            applicationStrategydetails = {
              applicationstrategydetails: (application?.applicationstrategydetails?.map(
                (_application_stratagy) => {
                  const feeDetailsCheck = response
                    .find(
                      (_stratagy_id) =>
                        Number(_stratagy_id.id) === Number(_application_stratagy?.strategyId)
                    )
                    ?.strategyFeeDetails?.map((_feeDetails) => _feeDetails.id)
                    .includes(_application_stratagy?.strategyFeeDetailId || '');
                  if (!responseId.includes(_application_stratagy?.strategyId?.toString())) {
                    return {
                      ..._application_stratagy,
                      isActive: false,
                    };
                  }
                  if (!feeDetailsCheck) {
                    return {
                      ..._application_stratagy,
                      isActive: false,
                    };
                  }
                  return _application_stratagy;
                }
              ) || []) as StrategyDetailsType[],
            };
          }
        } catch (e) {
          setButtonDisable(false);
          console.error((e as Error).message);
        }
      }
      if (isCustodianKotak(values?.custodian || '')) {
        applicants = application?.applicants.map((_applicant) => {
          if (
            _applicant?.fatcaAddress &&
            addressForTaxsMasters[_applicant?.fatcaAddress?.address_type || ''] !==
              addressForTaxsMasters.others
          ) {
            return {
              ..._applicant,
              fatcaAddress: {
                ...(_applicant?.fatcaAddress as ApplicantAddressType),
                isActive: false,
              },
            };
          } else {
            return _applicant;
          }
        });
      }

      const checkApplication = handleapplicationComparison(
        values,
        application,
        applicationStrategydetails,
        applicants,
        isSaveLater
      );

      //save for later route for investor at liveliness
      const investorEditSaveelaterRoute =
        referenceIdForInvestorPhotoCapture &&
        saveForLaterInvestorPhotoCapture(referenceIdForInvestorPhotoCapture, application);
      const referenceIdForSaveProceedRoute = referenceIdForInvestorPhotoCapture
        ? referenceIdForInvestorPhotoCapture
        : referenceDetail.esignReferenceId;

      if (id && !checkApplication) {
        setLoading(true);
        await dispatch(
          updateApplication({
            body: {
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              ...application!,
              ...applicationStrategydetails,
              rm_id: values?.rm_id,
              applicants,
              distributor_id: distributorId,
              subdistributorId,
              status:
                !hasPOA &&
                AMC_APPROVER_CHECK_FOR_INDIVIDUAL &&
                status !== 'draft' &&
                applyRoleBasedStatus(role)
                  ? 'sent_to_amc_approver'
                  : status,
              banks: isBankDetailsChanged(application?.bankDetails, values.bankDetails)
                ? application?.banks.length
                  ? application?.banks.map((applicant) => {
                      return { ...applicant, isActive: false };
                    })
                  : application?.banks
                : application?.banks,
              currentStep: SAVE_LATER_VALIDATION_CHECK ? 1 : isSaveLater ? 0 : 1,
              ...((!SAVE_LATER_VALIDATION_CHECK as boolean) && { saveForLater: isSaveLater }),
              //currentStep === null ? 1 : currentStep
              filledBy,
              custodian,
              bankDetails: checkNDPMS(accountType) ? bankDetails : '',
              ndpmsSectionEdited: showDialogForEdit ? true : application?.ndpmsSectionEdited,
            },
            applicationId: id,
            ...(saveType !== 'save and proceed' && {
              toastMessage: '',
            }),
          })
        );
        !isSaveLater
          ? history.push('contributor-details', {
              id,
              applicant1ReferenceId: referenceIdForSaveProceedRoute,
            })
          : referenceIdForInvestorPhotoCapture
          ? history.push(
              investorEditSaveelaterRoute.routePath,
              investorEditSaveelaterRoute.routeState
            )
          : history.push(saveForLater(role, id, referenceDetail.esignReferenceId));
      } else if (checkApplication) {
        if (isSaveLater) {
          enqueueSnackbar(`Application ${applicationNumber} - ` + ' Saved successfully', {
            variant: 'success',
            autoHideDuration: 3000,
          });
        }
        !isSaveLater
          ? history.push('contributor-details', {
              id,
              applicant1ReferenceId: referenceIdForSaveProceedRoute,
            })
          : referenceIdForInvestorPhotoCapture
          ? history.push(
              investorEditSaveelaterRoute.routePath,
              investorEditSaveelaterRoute.routeState
            )
          : history.push(saveForLater(role, id, referenceDetail.esignReferenceId));
      }
    } catch (e) {
      setLoading(false);
      console.error((e as Error).message);
    }
  };

  const manageSubmit = (values: DistributorDetailsProps) => {
    const { bankAccountFormCreated = false, showBankIcon = false } = application || {};
    const { bankDetails = '' } = values;
    const checkApplication = applicationComparison(application, {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      ...application,
      bankDetails: checkNDPMS(accountType) ? bankDetails : '',
    });
    if (
      showPopBankDetail(
        checkApplication,
        accountType,
        bankAccountFormCreated,
        showBankIcon,
        bankDetails,
        role
      )
    ) {
      setFinalValue(values);
      setShowShowForEdit(true);
    } else {
      onSubmit(values);
    }
  };

  const amcuserAsInvestor = refLoginCheck(
    authId,
    application as unknown as ApplicationProps,
    referenceDetail
  );

  const isFieldDisabled = [USER_ROLES.INVESTOR].includes(role) || amcuserAsInvestor;

  return (
    <Formik
      initialValues={initialValues}
      validate={(values: DistributorDetailsProps) => {
        try {
          validateYupSchema(
            values,
            distributorsValidationSchema(
              selectedDistributor,
              USER_ROLES.SRM === role
                ? ((mappedusersDetailsList?.mappedUsers || []) as any)
                : distributors,
              checkNDPMS(accountType),
              shouldValidateUponSaveLater(values.saveType)
            ),
            true,
            values
          );
        } catch (e) {
          return yupToFormErrors(e);
        }
      }}
      onSubmit={manageSubmit}
      enableReinitialize={true}>
      {({ handleSubmit, values, setValues, resetForm }) => (
        <Box component="form" noValidate onSubmit={handleSubmit}>
          <Notes
            displayContent={
              'This section specifies whether the application is from an Angel One RM/Distributor/RIA.'
            }
          />
          <Grid container rowSpacing={2} columnSpacing={5} sx={{ pt: '25px !important' }}>
            {[USER_ROLES.RM, USER_ROLES.INVESTOR].includes(role) && mappingRmWithDistributors && (
              <Grid item xs={12}>
                <UseRadioGroup
                  formLabel=""
                  name={`loginType`}
                  items={[
                    { label: 'RM', value: USER_ROLES.RM },
                    { label: 'Distributor', value: USER_ROLES.DISTRIBUTOR },
                    { label: 'RIA', value: USER_ROLES.RIA },
                  ]}
                  onChange={({ target: { value } }: React.ChangeEvent<HTMLInputElement>) => {
                    const distributorExists = !distributors?.some((disVal) => {
                      return (
                        !checkApplicableForYes(disVal?.isRia) && disVal.id === values?.distributorId
                      );
                    });

                    const riaExists = !distributors?.some((riaVal) => {
                      return (
                        checkApplicableForYes(riaVal?.isRia) && riaVal.id === values?.distributorId
                      );
                    });

                    if (values.loginType !== USER_ROLES.RM && values?.distributorId) {
                      handleDialogOpen(
                        'Changing the maker details will also clear all Distributor/RIA data. Are you sure you want to proceed?'
                      );
                      setLoginTypeRole(value as string);
                    } else if (
                      (values.distributorId &&
                        value === USER_ROLES.DISTRIBUTOR &&
                        distributorExists) ||
                      (values.distributorId && value === USER_ROLES.RIA && riaExists)
                    ) {
                      handleDialogOpen(
                        'Changing the maker details will also clear all Distributor/RIA data. Are you sure you want to proceed?'
                      );
                      setLoginTypeRole(value as string);
                    } else {
                      setLoginTypeRole('');
                      setValues({
                        ...values,
                        loginType: value,
                      });
                    }
                  }}
                />
              </Grid>
            )}
            {application?.srm_id &&
            ![
              USER_ROLES.DISTRIBUTOR,
              USER_ROLES.SUBDISTRIBUTOR,
              USER_ROLES.POAAPPROVER,
              USER_ROLES.RM,
              USER_ROLES.RIA,
            ].includes(role) ? (
              <SRMDetail
                savedDistributors={distributors || []}
                handleDialogOpen={handleDialogOpen}
                values={values}
                selectedDistributor={selectedDistributor}
                setSelectedDistributor={setSelectedDistributor}
                mappedusersDetailsList={mappedusersDetailsList as mappedUserUnderSrmType}
              />
            ) : (
              <>
                {(application?.rm_id || mappingRmWithDistributors) &&
                ![
                  USER_ROLES.DISTRIBUTOR,
                  USER_ROLES.SUBDISTRIBUTOR,
                  USER_ROLES.POAAPPROVER,
                  USER_ROLES.RIA,
                ].includes(role) &&
                values.loginType === USER_ROLES.RM ? (
                  <RMDetail />
                ) : (
                  <>
                    {(application?.distributor_id || mappingRmWithDistributors) && (
                      <DistributorDetail
                        handleDialogOpen={handleDialogOpen}
                        distributors={distributors?.filter((item) =>
                          values?.loginType === USER_ROLES.RIA ||
                          checkApplicableForYes(
                            (distributors || [])?.find((item) => item?.id === values?.distributorId)
                              ?.isRia || ''
                          )
                            ? checkApplicableForYes(item?.isRia)
                            : !checkApplicableForYes(item?.isRia)
                        )}
                        values={values}
                        selectedDistributor={selectedDistributor}
                        setSelectedDistributor={(subdistributors) =>
                          setSelectedDistributor(subdistributors)
                        }
                      />
                    )}
                  </>
                )}
              </>
            )}
            <Grid item xs={12}>
              <SubHeading sx={{ color: 'common.primary', letterSpacing: 0.5 + 'px' }}>
                {'Custodian Details'}
              </SubHeading>
            </Grid>
            <GridItem>
              <MFSelectField
                name={`custodian`}
                label={'Custodian Name *'}
                items={Object.keys(CustodianMaster)?.map((item) => ({
                  key: CustodianMaster[item],
                  value: item,
                }))}
                applyLabelStyles={true}
                disabled={true}
              />
            </GridItem>
            {checkNDPMS(accountType) && (
              <>
                {/* <Grid item xs={12}>
                  <SubHeading sx={{ color: 'common.primary', letterSpacing: 0.5 + 'px' }}>
                    {'Bank Details'}
                  </SubHeading>
                </Grid>
                <GridItem>
                  <MFSelectField
                    name={`bankDetails`}
                    label={'Bank Details *'}
                    items={Object.keys(NDPSMBankMaster).map((item) => ({
                      key: NDPSMBankMaster[item],
                      value: item,
                    }))}
                    applyLabelStyles={true}
                    disabled={
                      (values.loginType === USER_ROLES.DISTRIBUTOR && distributors.length === 0) ||
                      isFieldDisabled ||
                      disableBankDetail(
                        role,
                        application?.status,
                        application?.bankAccountFormCreated,
                        application?.showBankIcon
                      )
                    }
                  />
                </GridItem> */}
              </>
            )}
          </Grid>
          <OnEditDialogBox
            open={showDialogForEdit}
            setOpen={setShowShowForEdit}
            handleSubmit={onSubmit}
            values={finalvalue}
            message={'Please confirm if new bank account is not to be opened for this application'}
          />
          <FieldValidationNote />
          <ProceedSaveLater
            saveLater={() => {
              setValues({
                ...values,
                saveType: 'save for later',
              });
            }}
            saveAndProceed={() => {
              setValues({
                ...values,
                saveType: 'save and proceed',
              });
            }}
            disabled={buttonDisable}
            loader={loading}
            clickedButton={values.saveType}
          />
          <ConfirmationDialog
            message={dialogMessage}
            open={openDialog}
            setOpen={handleDialogClose}
            onSave={() => {
              handleDialogClose();
              resetForm();
              setValues({
                ...values,
                loginType: loginTypeRole || values.loginType,
                distributorNismNumber: null,
                distributorName: '',
                distributorPhone: '',
                distributorEmail: '',
                distributorId: null,
                subdistributorId: null,
                subdistributorName: '',
                subDistributorNismNumber: null,
                subdistributorEmail: '',
                subdistributorPhone: '',
              });
              setSelectedDistributor([]);
            }}
            onCancel={handleDialogClose}
          />
        </Box>
      )}
    </Formik>
  );
}
